import Vue from 'vue'
import App from './App.vue'
import router from './router/index';
import store from './store/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Swiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import WOW from 'wowjs'
import 'animate.css/animate.css';
import api from "./api/index.js";
import { imgUrl } from "./api/config";
import record from "@/components/record.vue";
import Header2 from "@/components/Header2.vue";
import enHeader2 from "@/components/en/enHeader2.vue";
import AOS from 'aos'
import 'aos/dist/aos.css'
function detectDevice() {
    const userAgent = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}
// 获取设备的宽度
const deviceWidth = document.documentElement.clientWidth;
if(deviceWidth<600){
    const fontSize = deviceWidth/10;
    document.documentElement.style.fontSize = fontSize + 'px';
    window.addEventListener('resize', () => {
        const newDeviceWidth = document.documentElement.clientWidth;
        const newFontSize = newDeviceWidth/10;
        document.documentElement.style.fontSize = newFontSize + 'px';
    });
}

AOS.init({
    //全局设置：
    disable: false, //接受以下值：'phone','tablet','mobile',布尔值，表达式或函数,禁用不同设备下的aos
    startEvent: "DOMContentLoaded", //在文档上分派的事件的名称，AOS应该在该事件上进行初始化
    initClassName: "aos-init", //初始化后应用的类
    animatedClassName: "aos-animate", //应用于动画的类
    useClassNames: false, //如果为真，将在滚动中添加data-aos的内容作为类
    disableMutationObserver: false, //取消自动突变检测(高级)
    debounceDelay: 50, //在调整窗口大小时使用的取消延迟(高级)
    throttleDelay: 99, //滚动页面时使用的油门延迟（高级）

    //可以通过data-aos属性逐个设置的设置：
    offset: 150, //初始触发点的偏移量(单位:px)
    delay: 100, //延迟时间值从0到3000 ，步长为50毫秒，
    duration: 1000, //持续时间,值从0到3000，步长为50毫秒
    easing: "ease", // AOS动画的默认缓动
    once: true, //动画是否应该只发生一次
    mirror: true, //当滚动经过元素时，是否应该将其动画化
    anchorPlacement: "top-bottom", //定义元素相对于窗口的哪个位置应该触发动画
});

AOS.init() //初始化
Vue.prototype.$isMobile = detectDevice();
Vue.use(Swiper);
Vue.use(ElementUI);
Vue.component('record', record);
Vue.component('Header2', Header2);
Vue.component('enHeader2', enHeader2);
Vue.prototype.$wow = new WOW.WOW({
    live: true // 如果不需要动态检测新元素，可以设置为 false
});
  
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$staticImg = imgUrl;

new Vue({
    mounted() {
        this.$wow.init();
    },
    router,
    el: '#app',
    store,
    render: h => h(App),
}).$mount('#app')